var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.6071C18.3876 11.6071 19.1071 10.8876 19.1071 9.99996C19.1071 9.11236 18.3876 8.39282 17.5 8.39282C16.6124 8.39282 15.8928 9.11236 15.8928 9.99996C15.8928 10.8876 16.6124 11.6071 17.5 11.6071Z",
    fill: "#FF7984"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49996 11.6071C3.38756 11.6071 4.1071 10.8876 4.1071 9.99996C4.1071 9.11236 3.38756 8.39282 2.49996 8.39282C1.61236 8.39282 0.892822 9.11236 0.892822 9.99996C0.892822 10.8876 1.61236 11.6071 2.49996 11.6071Z",
    fill: "#FF7984"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3035 3.50484L15.6506 15.7776C15.8872 16.645 15.2342 17.5 14.335 17.5H5.63297C4.73382 17.5 4.0808 16.645 4.31738 15.7776L7.66449 3.50484C7.82629 2.91157 8.36514 2.5 8.98007 2.5H10.9879C11.6029 2.5 12.1417 2.91157 12.3035 3.50484Z",
    fill: "#FF3949"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -2.46533,
    y: 1.17847,
    width: 24.6567,
    height: 17.1072
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_11312_3092_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11312_3092)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99978 14.2856C13.9176 14.2856 16.9326 11.8117 18.0742 8.34081C18.6288 6.65447 17.1321 5.17847 15.3569 5.17847H3.03549C2.14789 5.17847 1.41454 5.90297 1.55111 6.78C2.21543 11.046 5.51646 14.2856 9.99978 14.2856Z",
    fill: "#FA605C",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11312_3092",
    x: -2.46533,
    y: 1.17847,
    width: 24.6567,
    height: 17.1072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11312_3092"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_11312_3092_clip_path",
    transform: "translate(2.46533 -1.17847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99978 14.2856C13.9176 14.2856 16.9326 11.8117 18.0742 8.34081C18.6288 6.65447 17.1321 5.17847 15.3569 5.17847H3.03549C2.14789 5.17847 1.41454 5.90297 1.55111 6.78C2.21543 11.046 5.51646 14.2856 9.99978 14.2856Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinner);
export default __webpack_public_path__ + "static/media/dinner.796220240a888f17173d718657059835.svg";
export { ForwardRef as ReactComponent };